import { useState as e } from "react";
import { isNil as t } from "es-toolkit/compat";
//#region src/hooks/useClipboard.ts
var n = (n) => {
	let { timeout: r = 2e3 } = n ?? {}, [i, a] = e(null), [o, s] = e(!1), [c, l] = e(null), u = (e) => {
		c && clearTimeout(c), l(setTimeout(() => s(!1), r)), s(e);
	};
	return {
		copy: (e) => {
			t(navigator.clipboard) ? a(/* @__PURE__ */ Error("useClipboard: navigator.clipboard is not supported")) : navigator.clipboard.writeText(e).then(() => u(!0)).catch((e) => a(e));
		},
		reset: () => {
			s(!1), a(null), c && clearTimeout(c);
		},
		error: i,
		copied: o
	};
};
//#endregion
export { n as default };

//# sourceMappingURL=useClipboard.js.map